import { HttpClient } from '@angular/common/http';
import { Service, inject } from '@angular/core';
import { ProductSelectItem } from '@app/types/product.type';
import { Observable } from 'rxjs/internal/Observable';
import { environment } from '@env';
import { BehaviorSubject, filter, finalize, of, shareReplay, switchMap } from 'rxjs';
import { UserService } from './user.service';
import { BarcodeRule } from '@app/types/barcode-rule.type';

@Service()
export class SharedDataService {
	readonly #httpClient = inject(HttpClient);
	readonly #userService = inject(UserService);

	readonly #loadingProductsSub$ = new BehaviorSubject(false);

	loadingProducts$ = this.#loadingProductsSub$.asObservable().pipe(
		shareReplay(1)
	)

	allProducts$ = this.#userService.currentShop$.pipe(
		filter((shop) => !!shop),
		switchMap((shop) => this.#fetchAllProducts({ id_shop: shop.id })),
		shareReplay(1)
	);
	barcodeRules$ = this.#fetchBarcodeRules().pipe(
		shareReplay(1)
	);

	#fetchAllProducts({ id_shop }: { id_shop: number | null } = { id_shop: null }): Observable<ProductSelectItem[]> {
		this.#loadingProductsSub$.next(true);
		return this.#httpClient.get<ProductSelectItem[]>(`${environment.apiUrl}/shops/${id_shop}/products/short`).pipe(
			finalize(() => this.#loadingProductsSub$.next(false))
		);
	}

	#fetchBarcodeRules(): Observable<BarcodeRule[]> {
		return of(barcodeRules);
	}
}

const barcodeRules: BarcodeRule[] = [
	{
		"type": "W",
		"expression": "^2240719([0-9][0-9])([0-9][0-9][0-9])",
		"name": "Exception 22 en kg 2240719"
	},
	{
		"type": "FP",
		"expression": "^26.....([0-9][0-9][0-9])([0-9][0-9])",
		"name": "26 en Franc (Computed Weight)"
	},
	{
		"type": "FP",
		"expression": "^28.....([0-9][0-9][0-9])([0-9][0-9])",
		"name": "28 en Franc (Computed Weight)"
	},
	{
		"type": "W",
		"expression": "^2240718([0-9][0-9])([0-9][0-9][0-9])",
		"name": "Exception 22 en kg"
	},
	{
		"type": "FP",
		"expression": "^22.....([0-9][0-9][0-9])([0-9][0-9])",
		"name": "FF Priced Barcodes"
	},
	{
		"type": "P",
		"expression": "^23.....([0-9][0-9][0-9])([0-9][0-9])",
		"name": "Price Barcodes 2 Decimals"
	},
	{
		"type": "FP",
		"expression": "^24.....([0-9][0-9][0-9])([0-9][0-9])",
		"name": "24 en Francs"
	},
	{
		"type": "FP",
		"expression": "^02.....([0-9][0-9][0-9])([0-9][0-9])",
		"name": "Price Barcodes (Computed Weight)"
	},
	{
		"type": "W",
		"expression": "^21.....([0-9][0-9])([0-9][0-9][0-9])",
		"name": "Weight Barcodes 3 Decimals"
	},
	{
		"type": "P",
		"expression": "^22.....([0-9][0-9][0-9])([0-9][0-9])",
		"name": "Local Product Price Barcodes"
	},
	{
		"name": "General",
		"type": "G",
		"expression": ".*"
	}
]
